import { RequestAction } from '@redux-requests/core';
import { AppsConstants } from 'modules/userApps/store/constants';
import { gql } from '@redux-requests/graphql';
import { transformHookResponse } from 'modules/userApps/store/responseTransforms';

export const getAppHooks = (id: string): RequestAction => ({
  type: AppsConstants.APP_GET_HOOKS,
  request: {
    query: gql`
      query ($id: ID!) {
        getApp(id: $id) {
          hooks {
            id
            name
            url
            secret
            secretHeader
            appId
            events {
              name
              types
            }
            isActive
            enableSourceEvents
          }
        }
      }
    `,
    variables: { id },
  },
  meta: {
    mutations: {
      [AppsConstants.APP + id]: (data, { getApp }) => {
        if (!getApp) {
          return getApp;
        }

        const { hooks } = getApp;
        const transformedHooks = hooks.map((hook: any) => transformHookResponse(hook));

        return { ...data, hooks: transformedHooks };
      },
    },
    // asMutation: true,
  },
});
